import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../config/firebaseConfig";
import { useToast } from "../../util/ToastProvider";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordComponent() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState<string | null>(null);
  const useToaster = useToast();
  const navigate = useNavigate();

  // ✅ Email validation
  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // ✅ Send reset password email
  async function sendEmail() {
    try {
      setLoading(true);
      setErrorStatus(null);

      console.log("console here")
      const authUserHandler = httpsCallable(functions, "authUserHandler");
      const result: any = await authUserHandler({
        type: "resetPassword",
        email,
      });

      if (result.data?.success) {
        useToaster.success(
          result.data?.message || "Password reset email sent successfully."
        );
        navigate(`/auth/await-email?type=reset&email=${encodeURIComponent(email)}`);
      } else {
        useToaster.error("Something went wrong while sending the email.");
      }
    } catch (err: any) {
      console.error("❌ Password reset failed:", err);
      useToaster.error(
        err.message || "Failed to send password reset email. Please try again."
      );
      setErrorStatus(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <h1 className="mt-4 text-dark-text text-[20px] font-medium">
        Reset your password
      </h1>

      <p className="mt-2 font-normal text-dark-text text-[12px]">
        You will receive an email with a password reset link. In case you don’t
        see it in your inbox, please check your spam folder.
      </p>

      <div className="mt-4">
        <label className="block text-white font-medium text-primary">
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`mt-2 block w-full rounded-xl border-0 ring-1 ring-inset ring-dark-border 
            !placeholder:text-dark-text !bg-dark-background-secondary-medium 
            px-3 py-2 !text-white !caret-white !outline-none !focus:outline-none 
            focus:ring-2 !focus:ring-white 
            ${errorStatus?.includes("email") ? "ring-red-400 focus:ring-red-500" : ""}`}
          placeholder="you@example.com"
          required
        />
        {email.length > 0 && !isValidEmail(email) && (
          <p className="mt-1 text-sm text-red-500 font-medium">
            Please enter a valid email address.
          </p>
        )}
      </div>

      {/* ✅ Fixed disabled logic and button label */}
      <button
        type="submit"
        onClick={sendEmail}
        disabled={loading || !isValidEmail(email)}
        className="mt-6 w-full rounded-xl bg-indigo-600 px-4 py-2.5 text-white text-sm font-medium 
                   hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? "Sending email..." : "Send Reset Link"}
      </button>

      <div className="mt-6 text-sm text-white text-center flex align-start gap-2">
        Go back to
        <a href="/auth/login" className="underline">
          Sign in
        </a>
        page
      </div>
    </>
  );
}
